import { afterGet as globalAfterGet } from "services/sosInventoryService/afterGet";
import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/itemReceipt/schema";
import { purchasingTransactionAfterGet } from "services/sosInventoryService/purchasingTransaction/afterGet";
import {
  transformFields,
  transformLineItemFields,
  transformSerials,
} from "services/utility/afterGet";

import { OBJECT_TYPES } from "appConstants";
import { LINE_ITEM_FIELDS } from "editConfig";

const OBJECT_TYPE = OBJECT_TYPES.ITEM_RECEIPT.fullString;

export function afterGet(record) {
  let newRecord = transformFields(record, FIELDS_TO_TRANSFORM);

  // convert payment to look like a typical reference field
  newRecord.payment = { id: record.payment };

  newRecord.lines = transformLineItemFields(
    newRecord.lines,
    LINE_ITEM_FIELDS[OBJECT_TYPE]
  );

  // transform serials based on serialTracked value
  newRecord.lines = newRecord.lines.map((line) => ({
    ...line,
    serials: transformSerials(line.itemDetails.serialTracking, line.serials),
  }));

  newRecord = purchasingTransactionAfterGet(newRecord);
  return globalAfterGet(newRecord);
}
